/**
 * 路由配置
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import setting from '@/config/setting';
import EleLayout from '@/layout';
import { menuToRoutes } from 'ele-admin';
import NProgress from 'nprogress';

Vue.use(VueRouter);

export const STANDALONE_ROUTES = [];

const routes = [
  {
    path: '/login',
    component: () => import('@/views/login/login'),
    meta: { title: '登录' }
  },
  {
    path: '*',
    component: () => import('@/views/exception/404')
  }
];

const router = new VueRouter({
  routes,
  mode: 'history'
});

// 路由守卫
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  updateTitle(to);

  if (setting.takeToken()) {
    if (STANDALONE_ROUTES.includes(to.path) || to.meta.standalone) {
      next();
      return;
    }
    if (!store.state.user.menus) {
      store
        .dispatch('user/getMenus')
        .then(({ menus, home }) => {
          router.addRoute({
            path: '/',
            component: EleLayout,
            redirect: setting.homePath || home,
            children: menuToRoutes(menus, (component) =>
              import('@/views' + component).catch((err) => {
                console.error('[menu] missing view:', component, err);
                return import('@/views/exception/404');
              })
            )
          });
          next({ ...to, replace: true });
        })
        .catch(() => {
          NProgress.done(true);
          next();
        });
    } else {
      next();
    }
  } else if (setting.whiteList.includes(to.path)) {
    next();
  } else {
    next({ path: '/login', query: to.path === '/' ? {} : { from: to.path } });
  }
});

router.afterEach(() => {
  setTimeout(() => {
    NProgress.done(true);
  }, 300);
});

router.onError(() => {
  NProgress.done(true);
});

export default router;

/**
 * 更新浏览器标题
 */
function updateTitle(route) {
  if (!route.path.startsWith('/redirect/')) {
    const names = [];
    if (route && route.meta && route.meta.title) {
      names.push(route.meta.title);
    }
    const appName = process.env.VUE_APP_NAME;
    if (appName) {
      names.push(appName);
    }
    document.title = names.join(' - ');
  }
}
